import styled from 'styled-components'
import Box from 'components/shared/Box'

const InfoWrapper = styled(Box)`
    background-color: ${({ theme }) => theme.colors.grayscale_0};
    box-shadow: 0 -12px 35px rgba(138, 150, 198, 0.05);
    border-radius: 8px;
    width: 100%;
`

export default InfoWrapper
